import React from "react";

import RolesPieChart from "./charts/roles_pie_chart";
import RolesPieReasonChart from "./charts/roles_pie_reasons_chart";
import css from "./roles_pie_section.module.scss";

const RolesPieSection = () => (
  <div className={css.pieWrapper}>
    <RolesPieChart />
    <RolesPieReasonChart />
  </div>
);

export default RolesPieSection;
